interface RoutesProps {
  [key: string]: string
}
export const routes: RoutesProps = {
  HOME: '/',
  NETWORKS: '/networks',
  REGISTER: '/register',
  LOGIN: '/login',
  USER_AGREEMENTS: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy',
  COOKIE_POLICY: '/cookie-policy',
  ABOUT_US: '/about-us',
  HELP: '/faq',
  CONTACTS: '/contacts',
  SUPPORT: '/tickets/new',
  TELEGRAM: 'https://t.me/AdSimple_me',
  FACEBOOK: 'https://www.facebook.com/people/AdSimple/61566322094569/',
  YOUTUBE: 'https://www.youtube.com/channel/UCkp8PHO7LYgMn5Ddth2f-DQ',
  SERVICES: '/services/',
  ADD_NETWORKS: '/#add_networks',
  RENT_ADS_ACCOUNT: '/#rent_ads_account',
  DEPOSIT_METHODS: '/#deposit_methods',
  AGENCY: '/#agency',
  CPA_NETWORK: '/#cpa_network'
} as const
